import { type SetStateAction, useCallback, useEffect, useState } from 'react';

import useCurrentUser from '~/hooks/useCurrentUser';

import { readPinnedLensIds, savePinnedLensIds, subscribeLensPins } from './lensPins';

/** The rail, landing and library share one account's shortcuts and receive the same updates. */
export function useLensPins() {
  const { user } = useCurrentUser();
  const email = user?.email;
  const [snapshot, setSnapshot] = useState(() => ({ email, ids: readPinnedLensIds(email) }));
  const ids = snapshot.email === email ? snapshot.ids : readPinnedLensIds(email);
  useEffect(() => {
    const sync = () => setSnapshot({ email, ids: readPinnedLensIds(email) });
    sync();
    return subscribeLensPins(sync, email);
  }, [email]);
  const setIds = useCallback(
    (value: SetStateAction<Array<string>>) => {
      const next = typeof value === 'function' ? value(readPinnedLensIds(email)) : value;
      savePinnedLensIds(next, email);
      setSnapshot({ email, ids: next });
    },
    [email],
  );
  return [ids, setIds] as const;
}
